var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import services from '../../services';
import { debounce } from '../../utils';
import * as actionTypes from './constants';
var PermissionService = services.PermissionService;
/** optimized permissions fetching with queue and debounce
 *
 * intended for unpredictable frequent calls to check permissions on targets */
var PermissionHandler = /** @class */ (function () {
    function PermissionHandler() {
        var _this = this;
        this.permissionQueue = new Set();
        this.lockedTargets = new Set();
        /** add targets to permission fetching queue */
        this.updatePermissionQueue = function (targets) {
            targets.forEach(function (target) {
                _this.permissionQueue.add(target);
            });
        };
        /** clear specified targets from permission queue */
        this.clearPermissionQueue = function (targets) {
            targets.forEach(function (target) {
                if (_this.permissionQueue.has(target)) {
                    _this.permissionQueue.delete(target);
                }
            });
        };
        /** retrieve targets that were not yet sent and lock them */
        this.unlockedTargets = function () {
            var targets = Array.from(_this.permissionQueue).filter(function (p) { return !_this.lockedTargets.has(p); });
            targets.forEach(function (target) {
                _this.lockedTargets.add(target);
            });
            return targets;
        };
        /** clear specified targets from locked targets */
        this.clearUnlockedTargets = function (targets) {
            targets.forEach(function (target) {
                if (_this.lockedTargets.has(target)) {
                    _this.lockedTargets.delete(target);
                }
            });
        };
        /** internal optimized permissions fetching */
        this.fetchPermissions = function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
            var targets, _a, object, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        targets = this.unlockedTargets();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        if (!(targets.length > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, PermissionService.getPermissionsByTargets(targets)];
                    case 2:
                        _a = (_b.sent()).object, object = _a === void 0 ? {} : _a;
                        dispatch({
                            type: actionTypes.GET_PERMISSIONS_SUCCESS,
                            permissions: object,
                        });
                        this.clearPermissionQueue(targets);
                        _b.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_1 = _b.sent();
                        console.error(e_1);
                        dispatch({
                            type: actionTypes.GET_PERMISSIONS_FAILURE,
                        });
                        return [3 /*break*/, 5];
                    case 5:
                        this.clearUnlockedTargets(targets);
                        return [2 /*return*/];
                }
            });
        }); };
        this.debouncedFetch = debounce(this.fetchPermissions, 250);
        this.getPermissions = function (dispatch, targets) {
            _this.updatePermissionQueue(targets);
            dispatch({
                type: actionTypes.GET_PERMISSIONS_REQUEST,
            });
            _this.debouncedFetch(dispatch);
        };
    }
    return PermissionHandler;
}());
export { PermissionHandler };
